export const modalState = {
  UPLOAD_CUSTOMERS: 'upload-customers',
  UPLOAD_SUCCESS: 'upload-success',
  AUDIENCE_LIST_SUCCESS: 'audience-list-success',
  EDIT_COPY: 'edit-copy',
  EDIT_SUBJECT: 'edit-subject'
}